import {useState} from 'react';
import {MenuButton} from '@/components/Sidebar/MenuButton';
import {DataSourceModal} from '@/map/components/DataSourceModal';
import {ReactComponent as RefIcon} from './assets/reference-icon.svg';

export const DataSourceMenu = () => {
  const [openDataSourceModal, setOpenDataSourceModal] =
    useState<boolean>(false);

  const toggleMenu = () => setOpenDataSourceModal((prev) => !prev);

  return (
    <>
      <MenuButton name="정보 출처" icon={RefIcon} onClick={toggleMenu} />
      {openDataSourceModal && <DataSourceModal onClose={toggleMenu} />}
    </>
  );
};
